import { preregisterationForm } from "./Slice/preRegistrationFormSlice";

export const validateBeforeSubmit = ({
    temp,
    available,
    getAgeCondition,
    setErrinterest,
}) => {
    if (temp.length === 0) {
        setErrinterest("Please select at least one.");
        return false;
    }

    if (!available) return false;
    if (!getAgeCondition) return false;

    return true;
};

export const prepareFormData = (
    data,
    course,
    graduation,
    next,
    temp
) => ({
    ...data,
    course_type: course,
    graduation_year: graduation,
    next_plan: next,
    interest: temp,
});

export const handleFormSubmission = async (dispatch, params, location) => {
    const response = await dispatch(
        preregisterationForm(params, location)
    ).unwrap();
    return response?.data?.message || "Submitted successfully!";
};

export const handleSubmissionError = (err) => {
    return err?.error || "Something went wrong";
};
